<template>
  <div class="row full-width" v-for="(item, index) in form" :key="item._id">
    <div v-if="index > 0">AND</div>
    <ConditionItem
      :index="index"
      :length="form.length"
      :modelValue="form[index]"
      @update:modelValue="(val) => updateFormItem(index, val)"
      @deleteItem="onDeleteItem"
      :isAudienceBuilder="true"
      class="q-mb-sm q-mt-sm"
    />
  </div>
  <div class="q-mt-sm add-condition-block">
    <q-btn flat color="black" icon="add" label="条件追加（AND）" @click="addCondition" class="full-width"/>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IAudienceBuilderConditionSetting } from '@/utils/types'
import ConditionItem from '@/components/common/condition-setting/ConditionItem.vue'
import { v4 as uuidv4 } from 'uuid'

@Options({
  components: { ConditionItem },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class ConditionAnd extends Vue {
  @Prop({ default: () => [] })
  modelValue!: IAudienceBuilderConditionSetting[]

  get form() {
    if (this.modelValue && this.modelValue.length > 0) {
      return this.modelValue
    }
    return [
      {
        _id: uuidv4(),
        type: '',
        data_id: [],
        column_name: '',
        text: '',
        filter: 'include',
        date: '',
      },
    ]
  }

  @Watch('modelValue', { deep: true, immediate: false })
  onModelValueChange(newVal: IAudienceBuilderConditionSetting[], oldVal: IAudienceBuilderConditionSetting[]) {
    if (!oldVal) return
    // console.log('ConditionAnd modelValue changed', { newVal, oldVal })
    // Emit update to parent when modelValue changes
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      this.$emit('update:modelValue', newVal)
    }
  }

  updateFormItem(index: number, value: IAudienceBuilderConditionSetting) {
    const newForm = [...this.form]
    // Create a deep copy of the value to ensure we have the latest data
    newForm[index] = { ...value }
    console.log('ConditionAnd updateFormItem', {
      index,
      value: JSON.stringify(value),
      newForm: JSON.stringify(newForm),
    })
    this.$emit('update:modelValue', newForm)
  }

  addCondition() {
    const item: IAudienceBuilderConditionSetting = {
      _id: uuidv4(),
      type: '',
      data_id: [],
      column_name: '',
      text: '',
      filter: '',
    }
    const newForm = [...this.form, item]
    this.$emit('update:modelValue', newForm)
  }

  onDeleteItem(index: number) {
    if (index >= 0 && index < this.form.length) {
      const newForm = [...this.form]
      newForm.splice(index, 1)
      this.$emit('update:modelValue', newForm)
    }
  }

  created() {
    console.log(this.form)
  }
}
</script>

<style scoped lang="scss">
.add-condition-block {
  width: 100%;
  border: 1px dotted black;
  border-radius: 8px;
  // padding: 4px;
  display: flex;
  justify-content: center;
}
</style>
